import onReady from '../utils/onReady';
import $ from 'jquery';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class StickyHeader {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container",
        };

        $(window).scroll(() => {
            let winTop = $(window).scrollTop();
            if(winTop >= 60){
                this.dom.container.classList.add("fixed");
            }else{
                this.dom.container.classList.remove("remove-animation");
                this.dom.container.classList.remove("fixed");
            }//if-else
        });

    }

}


export default StickyHeader;